export enum GrantType {
  ClientCredentials = 'client_credentials',
  RefreshToken = 'refresh_token',
  Password = 'password'
}
